import { render } from "./HomeContent.vue?vue&type=template&id=4c472723&scoped=true&ts=true"
import script from "./HomeContent.vue?vue&type=script&lang=ts"
export * from "./HomeContent.vue?vue&type=script&lang=ts"

import "./HomeContent.vue?vue&type=style&index=0&id=4c472723&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c472723"]])

export default __exports__